/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type homeQueryVariables = {|
  tags: $ReadOnlyArray<string>,
  lang: string,
  limit?: ?number,
|};
export type homeQueryResponse = {|
  +spaces: ?$ReadOnlyArray<?{|
    +title: ?string,
    +type: ?string,
    +surface: ?number,
    +urlByLang: ?string,
    +location: ?{|
      +city: ?string,
      +locality: ?string,
    |},
    +pictures: ?$ReadOnlyArray<?{|
      +nameId: ?string,
      +extension: ?string,
      +predictName: ?string,
    |}>,
    +dataByCategory: ?{|
      +capacities: ?{|
        +capacity: ?number
      |},
      +price: ?{|
        +amount_excl_tax: ?number
      |},
      +corpoPrice: ?{|
        +amount_excl_tax: ?number
      |},
    |},
  |}>
|};
export type homeQuery = {|
  variables: homeQueryVariables,
  response: homeQueryResponse,
|};
*/


/*
query homeQuery(
  $tags: [String!]!
  $lang: String!
  $limit: Int
) {
  spaces: getSpacesByTags(lang: $lang, tags: $tags, categories: ["production"], limit: $limit) {
    title(lang: $lang)
    type
    surface
    urlByLang(lang: $lang)
    location {
      city
      locality
    }
    pictures(count: 1) {
      nameId
      extension
      predictName
      id
    }
    dataByCategory(category: "production") {
      capacities {
        capacity
      }
      price {
        amount_excl_tax
      }
      corpoPrice: price(input: {byViewer: true}) {
        amount_excl_tax
      }
    }
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "lang"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "limit"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "tags"
},
v3 = {
  "kind": "Variable",
  "name": "lang",
  "variableName": "lang"
},
v4 = [
  {
    "kind": "Literal",
    "name": "categories",
    "value": [
      "production"
    ]
  },
  (v3/*: any*/),
  {
    "kind": "Variable",
    "name": "limit",
    "variableName": "limit"
  },
  {
    "kind": "Variable",
    "name": "tags",
    "variableName": "tags"
  }
],
v5 = [
  (v3/*: any*/)
],
v6 = {
  "alias": null,
  "args": (v5/*: any*/),
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "surface",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": (v5/*: any*/),
  "kind": "ScalarField",
  "name": "urlByLang",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "SpaceLocation",
  "kind": "LinkedField",
  "name": "location",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "city",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "locality",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v11 = [
  {
    "kind": "Literal",
    "name": "count",
    "value": 1
  }
],
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nameId",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "extension",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "predictName",
  "storageKey": null
},
v15 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "amount_excl_tax",
    "storageKey": null
  }
],
v16 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "category",
      "value": "production"
    }
  ],
  "concreteType": "DataByCategory",
  "kind": "LinkedField",
  "name": "dataByCategory",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SpaceCapacities",
      "kind": "LinkedField",
      "name": "capacities",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "capacity",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Price",
      "kind": "LinkedField",
      "name": "price",
      "plural": false,
      "selections": (v15/*: any*/),
      "storageKey": null
    },
    {
      "alias": "corpoPrice",
      "args": [
        {
          "kind": "Literal",
          "name": "input",
          "value": {
            "byViewer": true
          }
        }
      ],
      "concreteType": "Price",
      "kind": "LinkedField",
      "name": "price",
      "plural": false,
      "selections": (v15/*: any*/),
      "storageKey": "price(input:{\"byViewer\":true})"
    }
  ],
  "storageKey": "dataByCategory(category:\"production\")"
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "homeQuery",
    "selections": [
      {
        "alias": "spaces",
        "args": (v4/*: any*/),
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "getSpacesByTags",
        "plural": true,
        "selections": [
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          {
            "alias": null,
            "args": (v11/*: any*/),
            "concreteType": "SpacePicture",
            "kind": "LinkedField",
            "name": "pictures",
            "plural": true,
            "selections": [
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/)
            ],
            "storageKey": "pictures(count:1)"
          },
          (v16/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "homeQuery",
    "selections": [
      {
        "alias": "spaces",
        "args": (v4/*: any*/),
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "getSpacesByTags",
        "plural": true,
        "selections": [
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          {
            "alias": null,
            "args": (v11/*: any*/),
            "concreteType": "SpacePicture",
            "kind": "LinkedField",
            "name": "pictures",
            "plural": true,
            "selections": [
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v17/*: any*/)
            ],
            "storageKey": "pictures(count:1)"
          },
          (v16/*: any*/),
          (v17/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6b17bb884187db498c1e7c748d973134",
    "id": null,
    "metadata": {},
    "name": "homeQuery",
    "operationKind": "query",
    "text": "query homeQuery(\n  $tags: [String!]!\n  $lang: String!\n  $limit: Int\n) {\n  spaces: getSpacesByTags(lang: $lang, tags: $tags, categories: [\"production\"], limit: $limit) {\n    title(lang: $lang)\n    type\n    surface\n    urlByLang(lang: $lang)\n    location {\n      city\n      locality\n    }\n    pictures(count: 1) {\n      nameId\n      extension\n      predictName\n      id\n    }\n    dataByCategory(category: \"production\") {\n      capacities {\n        capacity\n      }\n      price {\n        amount_excl_tax\n      }\n      corpoPrice: price(input: {byViewer: true}) {\n        amount_excl_tax\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'c9c539b6b6c7c145ac5acb573d20a94c';

module.exports = node;
